import { base as o } from "./base.mjs";
import { disabled as i, active as r, hover as t } from "./interactions.mjs";
import { size as e, iconSize as m } from "./size.mjs";
import { variant as p } from "./variant.mjs";
const s = {
  base: o,
  variant: p,
  size: e,
  iconSize: m,
  disabled: i,
  active: r,
  hover: t
};
export {
  s as iconButtonRecipe
};
